import React from "react";
import PoweredBy from "./powered-by";

export default function ChatFooter({ chatBotSetting }) {
  if (chatBotSetting?.showPoweredBy === false) return null;
  return (
    <footer className="chat-footer">
      <PoweredBy />
    </footer>
  );
}
